'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Controllable = require('../decorators/Controllable');

var _Controllable2 = _interopRequireDefault(_Controllable);

var _Hoverable = require('../decorators/Hoverable');

var _Hoverable2 = _interopRequireDefault(_Hoverable);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SyntheticEvent = require('../core/SyntheticEvent');

var _SyntheticEvent2 = _interopRequireDefault(_SyntheticEvent);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Style = require('../core/Style');

var _H = require('../elements/headings/H7');

var _H2 = _interopRequireDefault(_H);

var _UICaret = require('../icon/icons/UICaret');

var _UICaret2 = _interopRequireDefault(_UICaret);

var _UIClickable = require('../button/UIClickable');

var _UIClickable2 = _interopRequireDefault(_UIClickable);

var _UIDragHandle = require('../draggable/UIDragHandle');

var _UIDragHandle2 = _interopRequireDefault(_UIDragHandle);

var _UIExpandableContents = require('./UIExpandableContents');

var _UIExpandableContents2 = _interopRequireDefault(_UIExpandableContents);

var _renderProp = require('../utils/propTypes/renderProp');

var RenderProp = _interopRequireWildcard(_renderProp);

var _component = require('../utils/propTypes/component');

var _component2 = _interopRequireDefault(_component);

var _AccordionTransition = require('../transitions/AccordionTransition');

var _AccordionTransition2 = _interopRequireDefault(_AccordionTransition);

var _IconConstants = require('../icon/IconConstants');

var _ExpandableConstants = require('./ExpandableConstants');

var _times = require('HubStyleTokens/times');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var USE_OPTIONS = ['default', 'enclosed'];

var getEnclosedStyle = (0, _styledComponents.css)(['background-color:', ';border-width:1px 0;margin-bottom:-1px;'], _ExpandableConstants.EXPANDABLE_DARK_BACKGROUND);

var ExpandableActions = _styledComponents2.default.div.withConfig({
  displayName: 'UIExpandableSection__ExpandableActions'
})(['align-items:center;display:flex;margin-left:', ';*:first-child > * + *{margin-left:', ';}'], (0, _Style.remCalc)(_ExpandableConstants.EXPANDABLE_ACTIONS_SPACING_X), (0, _Style.remCalc)(_ExpandableConstants.EXPANDABLE_ACTIONS_SPACING_X));

var ExpandableWrapper = _styledComponents2.default.div.withConfig({
  displayName: 'UIExpandableSection__ExpandableWrapper'
})(['']);

var ExpandableHeader = _styledComponents2.default.div.withConfig({
  displayName: 'UIExpandableSection__ExpandableHeader'
})(['border-color:', ';border-style:solid;border-width:1px 0 0 0;display:flex;justify-content:space-between;padding-left:0;padding-right:', ';position:relative;', ';&::after{content:\'\';height:', ';margin-left:-1px;width:1px;}'], _ExpandableConstants.EXPANDABLE_DARK_BORDER_COLOR, (0, _Style.remCalc)(_ExpandableConstants.EXPANDABLE_PADDING_X), function (props) {
  return props.use === 'enclosed' ? getEnclosedStyle : null;
}, (0, _Style.remCalc)(54));
ExpandableHeader.propTypes = {
  use: _react.PropTypes.oneOf(USE_OPTIONS)
};

var ExpandableButton = (0, _styledComponents2.default)(_UIClickable2.default).withConfig({
  displayName: 'UIExpandableSection__ExpandableButton'
})(['color:', ';align-items:center;display:flex;flex:1 1 auto;padding:', ' 0;transition:color ', ' ease-out;user-select:none;&:hover:not([aria-disabled=\'true\']){color:', ';}'], function (props) {
  return props.disabled ? _ExpandableConstants.EXPANDABLE_OPENER_DISABLED_COLOR : undefined;
}, (0, _Style.remCalc)(10), _times.MICRO_TRANSITION_TIMING, _ExpandableConstants.EXPANDABLE_OPENER_HOVER_COLOR);

var ExpandableTitle = (0, _styledComponents2.default)(function (_ref) {
  var className = _ref.className,
      titleText = _ref.titleText;
  return (
    /*
     * Here, we need to null out the `aria-level` otherwise it defaults to `2`,
     * so we disable the lint rule to allow it to be a non-integer. Then we need
     * to disable the rule to allow `aria-level` to be there with `presentation`
     * since the <H7> component has a default of `role="heading"`.
     * */

    /* eslint-disable jsx-a11y/role-supports-aria-props */
    /* eslint-disable jsx-a11y/aria-proptypes */
    _react2.default.createElement(
      _H2.default,
      { 'aria-level': null, className: className, role: 'presentation' },
      titleText
    )
    /* eslint-enable jsx-a11y/aria-proptypes */
    /* eslint-enable jsx-a11y/role-supports-aria-props */

  );
}).withConfig({
  displayName: 'UIExpandableSection__ExpandableTitle'
})(['margin-bottom:0;']);
ExpandableTitle.propTypes = {
  titleText: _react.PropTypes.node
};

var ExpandableCaretHolder = _styledComponents2.default.span.withConfig({
  displayName: 'UIExpandableSection__ExpandableCaretHolder'
})(['display:flex;flex-shrink:0;justify-content:center;width:', ';'], (0, _Style.remCalc)(_ExpandableConstants.EXPANDABLE_PADDING_LEFT));

var ExpandableCaret = (0, _styledComponents2.default)(_UICaret2.default).attrs({
  color: _ExpandableConstants.EXPANDABLE_OPENER_COLOR,
  viewBoxHeight: _IconConstants.CARET_HEIGHT,
  viewBoxWidth: _IconConstants.CARET_WIDTH,
  height: 12,
  width: 5
}).withConfig({
  displayName: 'UIExpandableSection__ExpandableCaret'
})(['transition:all ', ' ease-in-out;transform:', ';'], _times.MICRO_TRANSITION_TIMING, function (props) {
  return props.open ? 'rotate(90deg)' : null;
});

var ExpandableDragHandleHolder = _styledComponents2.default.span.withConfig({
  displayName: 'UIExpandableSection__ExpandableDragHandleHolder'
})(['left:', ';opacity:', ';position:absolute;top:50%;transform:translateY(-50%);transition:opacity ', ' ease-out;'], (0, _Style.remCalc)(8), function (props) {
  return props.hovered ? '1' : '0';
}, _times.MICRO_TRANSITION_TIMING);

var StyledContentWrapper = (0, _styledComponents2.default)(_UIExpandableContents2.default).withConfig({
  displayName: 'UIExpandableSection__StyledContentWrapper'
})(['padding-top:', ';'], function (props) {
  return props.use === 'enclosed' && props.indentation !== 'none' ? (0, _Style.remCalc)(_ExpandableConstants.EXPANDABLE_DARK_PADDING_TOP) : null;
});

var DefaultContentWrapper = function DefaultContentWrapper(props) {
  var open = props.open,
      children = props.children,
      className = props.className,
      indentation = props.indentation,
      use = props.use;

  return _react2.default.createElement(
    StyledContentWrapper,
    {
      'aria-hidden': open ? 'false' : 'true',
      className: className,
      indentation: indentation,
      use: use
    },
    children
  );
};
DefaultContentWrapper.propTypes = {
  open: _react.PropTypes.bool,
  children: _react.PropTypes.node,
  indentation: _UIExpandableContents2.default.propTypes.indentation,
  use: _react.PropTypes.oneOf(USE_OPTIONS)
};

var DefaultCaret = function DefaultCaret(props) {
  var open = props.open;

  return _react2.default.createElement(ExpandableCaret, { open: open });
};

var UIExpandableSection = _react2.default.createClass({
  displayName: 'UIExpandableSection',

  propTypes: {
    actions: _react.PropTypes.node,
    children: _react.PropTypes.node,
    Caret: _component2.default,
    contentClassName: _react.PropTypes.string,
    ContentWrapper: RenderProp.getPropType(DefaultContentWrapper).isRequired,
    disabled: _react.PropTypes.bool.isRequired,
    draggable: _react.PropTypes.bool.isRequired,
    DragHandle: _component2.default,
    Header: RenderProp.getPropType(ExpandableHeader).isRequired,
    hovered: _react.PropTypes.bool,
    indentation: _UIExpandableContents2.default.propTypes.indentation,
    onOpenChange: _react.PropTypes.func,
    open: _react.PropTypes.bool,
    Opener: _component2.default,
    titleText: ExpandableTitle.propTypes.titleText,
    Title: RenderProp.getPropType(ExpandableTitle).isRequired,
    use: _react.PropTypes.oneOf(USE_OPTIONS)
  },

  getDefaultProps: function getDefaultProps() {
    return {
      Caret: DefaultCaret,
      ContentWrapper: DefaultContentWrapper,
      disabled: false,
      draggable: false,
      DragHandle: _UIDragHandle2.default,
      Header: ExpandableHeader,
      indentation: _UIExpandableContents2.default.defaultProps.indentation,
      open: false,
      Opener: ExpandableButton,
      Title: ExpandableTitle,
      use: 'default'
    };
  },
  handleClick: function handleClick() {
    var _props = this.props,
        onOpenChange = _props.onOpenChange,
        open = _props.open;

    onOpenChange((0, _SyntheticEvent2.default)(!open));
  },
  render: function render() {
    var _props2 = this.props,
        actions = _props2.actions,
        Caret = _props2.Caret,
        children = _props2.children,
        contentClassName = _props2.contentClassName,
        ContentWrapper = _props2.ContentWrapper,
        disabled = _props2.disabled,
        DragHandle = _props2.DragHandle,
        draggable = _props2.draggable,
        Header = _props2.Header,
        hovered = _props2.hovered,
        indentation = _props2.indentation,
        open = _props2.open,
        Opener = _props2.Opener,
        titleText = _props2.titleText,
        Title = _props2.Title,
        use = _props2.use,
        rest = _objectWithoutProperties(_props2, ['actions', 'Caret', 'children', 'contentClassName', 'ContentWrapper', 'disabled', 'DragHandle', 'draggable', 'Header', 'hovered', 'indentation', 'open', 'Opener', 'titleText', 'Title', 'use']);

    return _react2.default.createElement(
      ExpandableWrapper,
      rest,
      _react2.default.createElement(
        Header,
        { use: use },
        draggable ? _react2.default.createElement(
          ExpandableDragHandleHolder,
          { hovered: hovered },
          _react2.default.createElement(DragHandle, null)
        ) : null,
        titleText ? _react2.default.createElement(
          Opener,
          {
            'aria-expanded': open ? 'true' : 'false',
            disabled: disabled,
            onClick: this.handleClick
          },
          _react2.default.createElement(
            ExpandableCaretHolder,
            null,
            _react2.default.createElement(Caret, { open: open })
          ),
          _react2.default.createElement(Title, { titleText: titleText })
        ) : null,
        actions ? _react2.default.createElement(
          ExpandableActions,
          null,
          actions
        ) : null
      ),
      children ? _react2.default.createElement(
        _AccordionTransition2.default,
        { open: open },
        _react2.default.createElement(
          ContentWrapper,
          {
            open: open,
            className: contentClassName,
            indentation: indentation,
            use: use
          },
          children
        )
      ) : null
    );
  }
});

exports.default = (0, _Hoverable2.default)((0, _Controllable2.default)(UIExpandableSection, ['open']));
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2644/js/accordion/UIExpandableSection.js
// module id = 653
// module chunks = 3 4